import React, { useContext, useRef, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { useTranslation } from 'react-i18next';
import Topic from './Topic/Topic';
import Separate from './Separate/Separate';
import { NavigationContext as Context } from '../Context';
import { ThemeContext } from '../../App/ThemeContext';
import classes from './NavComponents.module.scss';

const NavComponents = () => {
  const { t } = useTranslation();
  const { contents, selected, filter } = useContext(Context);
  const { theme } = useContext(ThemeContext);
  const scrollbarRef = useRef();

  useEffect(() => {
    const selectedModule = document.getElementById(selected.content);

    if (selectedModule) {
      const scrollTop = selectedModule.offsetTop - 150;
      scrollbarRef.current.scrollTop(scrollTop);
    }
  }, [selected.content]);

  let searchDiv = null;
  if (filter) {
    searchDiv = (
      <div
        className={`${classes.SearchLabel} ${classes[theme]}`}
      >
        {t('search_results')}
      </div>
    );
  }

  return (
    <>
      {searchDiv}
      <Scrollbars
        ref={scrollbarRef}
        style={{ height: '' }}
        className={`${classes.NavWrapper} ${theme ? classes[theme] : ''}`}
        renderView={(props) => (
          <div {...props} style={{ ...props.style, overflowX: 'hidden', marginBottom: 0 }} />
        )}
        renderTrackVertical={(props) => (
          <div {...props} className={classes.ScrollbarVert} style={{ ...props.style, width: '10px' }} />
        )}
        renderThumbVertical={(props) => <div {...props} className={classes.ScrollbarThumb} />}
        autoHide
        hideTracksWhenNotNeeded
      >
        {contents.map((content, index) => {
          let elem = null;
          if (content.show) {
            if (content.type === 'separate') {
              elem = <Separate key={content.name} name={content.name} />;
            } else {
              elem = <Topic key={content.name} topic={content} index={index} />;
            }
          }
          return elem;
        })}
        <div id="search-results" />
      </Scrollbars>
    </>
  );
};

export default React.memo(NavComponents);
